import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EmptyOptionType } from 'src/components/atomic/Molecules/EmptyComponent'
import { ResponseDataBody } from 'src/types/websocket'

type CameraPageStateType = {
  EmptyComponentStatus: EmptyOptionType
  CameraStatus: 'default' | 'active' | 'loading'
  CamMicAuth: boolean
  callTime: { time: number; text: string }
}

export type CameraPageDataTypes = CameraPageStateType & ResponseDataBody.CameraStart

const initialState: CameraPageDataTypes = {
  EmptyComponentStatus: 'default',
  CameraStatus: 'default',
  CamMicAuth: true,
  TokenID: '',
  SessionID: '',
  callTime: { time: 0, text: '00 : 00 : 00' },
}

const CameraPageSlice = createSlice({
  name: 'CameraPage',
  initialState,
  reducers: {
    setEmptyComponentStatus(state, action: PayloadAction<EmptyOptionType>) {
      state.EmptyComponentStatus = action.payload
    },
    setCameraStatus(state, action: { payload: 'default' | 'active' | 'loading' }) {
      state.CameraStatus = action.payload
    },
    ResetEmptyComponentStatus(state) {
      state.EmptyComponentStatus = 'default'
    },
    ResetCameraStatus(state) {
      state.CameraStatus = 'default'
    },
    setCallTimeCounter(state, action) {
      state.callTime = {
        time: action.payload,
        text: handleCallTimeFormat(action.payload),
      }
    },
    ResetCallTime(state) {
      state.callTime = { time: 0, text: `00 : 00 : 00` }
    },
  },
})
const handleCallTimeFormat = (seconds: number) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  return (
    `${hours.toString().padStart(2, '0')}` +
    ' : ' +
    `${minutes.toString().padStart(2, '0')}` +
    ' : ' +
    `${remainingSeconds.toString().padStart(2, '0')}`
  )
}
export const {
  setEmptyComponentStatus,
  ResetEmptyComponentStatus,
  ResetCameraStatus,
  setCameraStatus,
  setCallTimeCounter,
  ResetCallTime,
} = CameraPageSlice.actions

export default CameraPageSlice.reducer
